import request from 'axios';
import { reset } from 'redux-form';
import idx from 'idx';
import queryString from 'query-string';
import rangeRight from 'lodash/rangeRight';
import sum from 'lodash/sum';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import moment from 'moment';
import { showBanner, TYPE_SUCCESS } from 'common/ducks/banner';
import { setBannerError } from 'error';
import {
  AUTOMATIONS_RESOURCE_NAME, GROUPS_RESOURCE_NAME, AUTOMATION_FORM_NAME, ATTRIBUTE_ENTRY_CONDITIONS,
  EVENT_ENTRY_CONDITIONS
} from 'email_automations/constants';
import { getAPIQueryString } from 'common/utils';
import { savePageCount } from 'common/pager/ducks';
import { sendTestEmail as sendTestEmailCommon } from 'email_automations/ducks/common';

// TODO: REMOVE
import random from 'lodash/random';

/* ACTIONS
================================================================================================ */
const FETCH_TOTALS = 'crowdspring/bumblebee/FETCH_TOTALS';
const FETCH_TOTALS_SUCCESS = 'crowdspring/bumblebee/FETCH_TOTALS_SUCCESS';

const FETCH_AUTOMATIONS = 'crowdspring/bumblebee/FETCH_AUTOMATIONS';
const FETCH_AUTOMATIONS_REQUEST = 'crowdspring/bumblebee/FETCH_AUTOMATIONS_REQUEST';
const FETCH_AUTOMATIONS_SUCCESS = 'crowdspring/bumblebee/FETCH_AUTOMATIONS_SUCCESS';

const FETCH_GROUP = 'crowdspring/bumblebee/FETCH_GROUP';
const FETCH_GROUP_REQUEST = 'crowdspring/bumblebee/FETCH_GROUP_REQUEST';
const FETCH_GROUP_SUCCESS = 'crowdspring/bumblebee/FETCH_GROUP_SUCCESS';

const FETCH_METRICS = 'crowdspring/bumblebee/FETCH_METRICS';
const FETCH_METRICS_SUCCESS = 'crowdspring/bumblebee/FETCH_METRICS_SUCCESS';

const PAUSE_AUTOMATION = 'crowdspring/bumblebee/PAUSE_AUTOMATION';
const PAUSE_AUTOMATION_SUCCESS = 'crowdspring/bumblebee/PAUSE_AUTOMATION_SUCCESS';

const RESUME_AUTOMATION = 'crowdspring/bumblebee/RESUME_AUTOMATION';
const RESUME_AUTOMATION_SUCCESS = 'crowdspring/bumblebee/RESUME_AUTOMATION_SUCCESS';

const SET_LIVE_AUTOMATION = 'crowdspring/bumblebee/SET_LIVE_AUTOMATION';
const SET_LIVE_AUTOMATION_SUCCESS = 'crowdspring/bumblebee/SET_LIVE_AUTOMATION_SUCCESS';

const END_AUTOMATION = 'crowdspring/bumblebee/END_AUTOMATION';
const END_AUTOMATION_SUCCESS = 'crowdspring/bumblebee/END_AUTOMATION_SUCCESS';

const FETCH_GROUPS = 'crowdspring/bumblebee/FETCH_GROUPS';
const FETCH_GROUPS_REQUEST = 'crowdspring/bumblebee/FETCH_GROUPS_REQUEST';
const FETCH_GROUPS_SUCCESS = 'crowdspring/bumblebee/FETCH_GROUPS_SUCCESS';

const PAUSE_GROUP = 'crowdspring/bumblebee/PAUSE_GROUP';
const PAUSE_GROUP_SUCCESS = 'crowdspring/bumblebee/PAUSE_GROUP_SUCCESS';

const RESUME_GROUP = 'crowdspring/bumblebee/RESUME_GROUP';
const RESUME_GROUP_SUCCESS = 'crowdspring/bumblebee/RESUME_GROUP_SUCCESS';

const END_GROUP = 'crowdspring/bumblebee/END_GROUP';
const END_GROUP_SUCCESS = 'crowdspring/bumblebee/END_GROUP_SUCCESS';

const SAVE_GROUP = 'crowdspring/bumblebee/SAVE_GROUP';

const FETCH_AUTOMATION = 'crowdspring/bumblebee/FETCH_AUTOMATION';
const FETCH_AUTOMATION_REQUEST = 'crowdspring/bumblebee/FETCH_AUTOMATION_REQUEST';
const FETCH_AUTOMATION_SUCCESS = 'crowdspring/bumblebee/FETCH_AUTOMATION_SUCCESS';

const SAVE_AUTOMATION = 'crowdspring/bumblebee/SAVE_AUTOMATION';

/* HELPERS
================================================================================================ */
const METRIC_LABELS = {
  unique_confirmed_opened: "opened",
  unique_clicked: "clicked",
  bounce: "bounces",
  spam_complaint: "spam reports"
};
const formatMetrics = (payload, period) => {
  const dates = rangeRight(period).map(n => moment().subtract(n, 'days'));
  const series = dates.map(date => {
    const dataForDate = Object.keys(payload).reduce((acc, metric) => ({
      ...acc,
      [METRIC_LABELS[metric] || metric]: (
        (payload[metric][date.format('YYYY-MM-DD')] || 0).toLocaleString()
      )
    }), {});

    return ({
      date: date.format('MMM D'),
      ...dataForDate
    });
  });

  const totals = Object.keys(payload).reduce((acc, metric) => ({
    ...acc,
    [METRIC_LABELS[metric] || metric]: sum(Object.values(payload[metric])).toLocaleString()
  }), {});

  return { series, totals };
}

/*TODOexport const cloneAutomationRequest = (id) => (
  request.post(`/api/v1/email-automations/${id}/clone/`)
); */
export const cloneAutomationRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Automation 10', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});

/*TODOexport const deleteAutomationRequest = (id) => (
  request.delete(`/api/v1/email-automations/${id}/`)
); */
export const deleteAutomationRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve();
  }, 1000);
});

/* TODOexport const createAutomationRequest = () => request.post('/api/v1/email-automations/'); */
export const createAutomationRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Automation 10', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});

/*TODOexport const cloneGroupRequest = (id) => (
  request.post(`/api/v1/email-automation-groups/${id}/clone/`)
);*/
export const cloneGroupRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Group 10', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});

/*TODOexport const deleteGroupRequest = (id) => (
  request.delete(`/api/v1/email-automation-groups/${id}/`)
); */
export const deleteGroupRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve();
  }, 1000);
});

//TODOexport const createGroupRequest = () => request.post('/api/v1/email-automation-groups/');
export const createGroupRequest = () => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ data: {
        id: 10, name: 'Group 10', status: "live", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_recipients_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_unsubscribe_total: 7, count_spam_complaint_total: 8 }});
  }, 1000);
});

export const fetchGroupRequest = (id) => request.get(`/api/v1/email-automation-groups/${id}/`);

/* INITIAL STATES
================================================================================================ */
const initialState = {
  totals: {},
  metrics: {},
  automations: [],
  automationCount: 0,
  isFetching: false,
  isFetchingSingle: false,
  groups: [],
  groupCount: 0
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  let fieldsOfInterest;

  switch (action.type) {
    case FETCH_TOTALS_SUCCESS:
      return {
        ...state,
        totals: action.payload
      };
    case FETCH_METRICS_SUCCESS:
      return {
        ...state,
        metrics: formatMetrics(action.payload, action.period)
      };
    case FETCH_AUTOMATIONS_REQUEST:
    case FETCH_GROUPS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_GROUP_REQUEST:
    case FETCH_AUTOMATION_REQUEST:
      return {
        ...state,
        isFetchingSingle: true
      };
    case FETCH_AUTOMATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        automations: action.payload.results,
        automationCount: action.payload.count
      };
    case FETCH_GROUP_SUCCESS:
      return {
        ...state,
        isFetchingSingle: false,
        group: {
          ...action.payload,
          name: action.payload.name || "Untitled group"
        }
      };
    case PAUSE_AUTOMATION_SUCCESS:
    case RESUME_AUTOMATION_SUCCESS:
    case SET_LIVE_AUTOMATION_SUCCESS:
    case END_AUTOMATION_SUCCESS:
      fieldsOfInterest = pick(
        action.payload, 'id', 'status', 'last_action', 'last_action_at', 'last_action_by'
      );
      return {
        ...state,
        automations: state.automations.map(a => (
          a.id === fieldsOfInterest.id? { ...a, ...fieldsOfInterest } : a
        )),
        automation: (
          idx(state, _ => _.automation.id) === fieldsOfInterest.id?
          { ...state.automation, ...fieldsOfInterest } : state.automation
        )
      };
    case FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        groups: action.payload.results,
        groupCount: action.payload.count
      };
    case PAUSE_GROUP_SUCCESS:
    case RESUME_GROUP_SUCCESS:
    case END_GROUP_SUCCESS:
      fieldsOfInterest = pick(
        action.payload, 'id', 'status', 'last_action', 'last_action_at', 'last_action_by'
      );
      return {
        ...state,
        groups: state.groups.map(g => (
          g.id === fieldsOfInterest.id? { ...g, ...fieldsOfInterest } : g
        )),
        group: (
          idx(state, _ => _.group.id) === fieldsOfInterest.id?
          { ...state.group, ...fieldsOfInterest } : state.group
        )
      };
    case FETCH_AUTOMATION_SUCCESS:
      return {
        ...state,
        isFetchingSingle: false,
        automation: {
          ...action.payload,
          name: action.payload.name || "Untitled automation"
        }
      };
    default:
      return state;
  }
}

export const fetchTotals = (groupId) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: FETCH_TOTALS_SUCCESS, payload: {
    draft: groupId? 1 : 5, live: 6, paused: 10, ended: 15
  } }), 1000);

  const queryStr = queryString.stringify({ group: groupId });

  return dispatch({
    type: FETCH_TOTALS,
    promise: request.get(`/api/v1/email-automations/totals/?${queryStr}`),
  });
};

export const fetchAutomations = (query, status, groupId) => (dispatch) => {
  const extraAPIQuery = {
    group: groupId,
    status: status === "all"? undefined : status
  };
  const queryStr = getAPIQueryString(AUTOMATIONS_RESOURCE_NAME, query, { extraAPIQuery });
  //TODOconst promise = request.get(`/api/v1/email-automations/?${queryStr}`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
        count: groupId? 31 : 45,
        limit: 24,
        results: [
          { id: 1, name: 'Automation 1', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 2, name: 'Automation 2', status: "live", last_action: 'edit', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 3, name: 'Automation 3', status: "paused", last_action: 'set_live', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 4, name: 'Automation 4', status: "ended", last_action: 'pause', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 5, name: 'Automation 5', status: "draft", last_action: 'resume', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 6, name: 'Automation 6', status: "draft", last_action: 'end', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
        ]
      }});
    }, 1000);
  });

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(AUTOMATIONS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_AUTOMATIONS,
    promise
  });
};

export const fetchGroup = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: FETCH_GROUP_SUCCESS, payload: {
    id: 1, name: "Group 1", status: 'live', description: "Group 1 description", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100, count_goal_2_total: 10, count_goal_3_total: 12, count_goal_4_total: 14
  } }), 1000);

  return dispatch({
    type: FETCH_GROUP,
    promise: fetchGroupRequest(id)
  });
};

// TODO: remove this
const createFakeMetrics = (period) => {
  const dates = rangeRight(period).map(n => moment().subtract(n, 'days'));
  const metrics = [
    "targeted", "sent", "delivered", "unique_confirmed_opened", "unique_clicked", "bounce",
    "spam_complaint"
  ];
  return metrics.reduce((acc, m) => {
    const values = dates.reduce((acc, d) => {
      return {
        ...acc,
        [d.format('YYYY-MM-DD')]: random(1000)
      };
    }, {});

    return {
      ...acc,
      [m]: values
    };
  }, {});
}

export const fetchMetrics = (period, groupId) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: FETCH_METRICS_SUCCESS, payload: createFakeMetrics(period), period}), 1000);

  const queryStr = queryString.stringify({ period, group: groupId });

  return dispatch({
    type: FETCH_METRICS,
    promise: request.get(`/api/v1/email-automations/metrics/?${queryStr}`),
    period
  });
};

export const pauseAutomation = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: PAUSE_AUTOMATION_SUCCESS, payload: {
    id: 2, status: 'paused'
  } }), 1000);
  //const promise = request.post(`/api/v1/email-automations/${id}/pause/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: PAUSE_AUTOMATION,
    promise
  });

  return promise;
};

export const resumeAutomation = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: RESUME_AUTOMATION_SUCCESS, payload: {
    id: 3, status: 'live'
  } }), 1000);
  //const promise = request.post(`/api/v1/email-automations/${id}/resume/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: RESUME_AUTOMATION,
    promise
  });

  return promise;
};

export const setLiveAutomation = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: SET_LIVE_AUTOMATION_SUCCESS, payload: {
    id: 1, status: 'live'
  } }), 1000);
  //const promise = request.post(`/api/v1/email-automations/${id}/set_live/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  promise.catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Unknown error';
    dispatch(setBannerError('Error setting automation live', errorMsg));
  });

  dispatch({
    type: SET_LIVE_AUTOMATION,
    promise
  });

  return promise;
};

export const endAutomation = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: END_AUTOMATION_SUCCESS, payload: {
    id: 2, status: 'ended'
  } }), 1000);
  //const promise = request.post(`/api/v1/email-automations/${id}/end/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: END_AUTOMATION,
    promise
  });

  return promise;
};

export const fetchGroups = (query) => (dispatch) => {
  const queryStr = getAPIQueryString(GROUPS_RESOURCE_NAME, query);
  //TODOconst promise = request.get(`/api/v1/email-automation-groups/?${queryStr}`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {
        count: 30,
        limit: 24,
        results: [
          { id: 1, name: 'Group 1', status: "draft", last_action: 'create', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 2, name: 'Group 2', status: "live", last_action: 'edit', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 3, name: 'Group 3', status: "paused", last_action: 'set_live', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 4, name: 'Group 4', status: "ended", last_action: 'pause', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 5, name: 'Group 5', status: "", last_action: 'resume', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
          { id: 6, name: 'Group 6', status: "draft", last_action: 'end', last_action_by: { first_name: "Katie" }, last_action_at: '2019-09-12T17:46:00.331963Z', count_leads_total: 3, count_delivered_total: 4, count_unique_confirmed_opened_total: 5, count_unique_clicked_total: 6, count_exited_leads_total: 7, count_goal_1_total: 8, count_targeted_total: 100 },
        ]
      }});
    }, 1000);
  });

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(GROUPS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_GROUPS,
    promise
  });
};

export const pauseGroup = (id) => (dispatch) => {
  setTimeout(() => dispatch({ type: PAUSE_GROUP_SUCCESS, payload: {
    id: 2, status: 'paused'
  } }), 1000);
  //TODOconst promise = request.post(`/api/v1/email-automation-groups/${id}/pause/`);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: PAUSE_GROUP,
    promise
  });

  return promise;
};

export const resumeGroup = (id) => (dispatch) => {
  setTimeout(() => dispatch({ type: RESUME_GROUP_SUCCESS, payload: {
    id: 3, status: 'live'
  } }), 1000);
  //TODOconst promise = request.post(`/api/v1/email-automation-groups/${id}/resume/`); /*
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: RESUME_GROUP,
    promise
  });

  return promise;
};

export const endGroup = (id) => (dispatch) => {
  setTimeout(() => dispatch({ type: END_GROUP_SUCCESS, payload: {
    id: 2, status: 'ended'
  } }), 1000);
  //TODOconst promise = request.post(`/api/v1/email-automation-groups/${id}/end/`); /*
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {} });
    }, 1000)
  });

  dispatch({
    type: END_GROUP,
    promise
  });

  return promise;
};

export const saveGroup = (id, data) => (dispatch) => {
  //TODOconst promise = request.patch(`/api/v1/email-automation-groups/${id}/`, data);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {}});
    }, 1000);
  });

  promise.then(() => {
    dispatch(
      showBanner('Success', 'Automation group successfully saved.', undefined, TYPE_SUCCESS)
    );
  }).catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Make sure the data you entered is correct.';
    dispatch(setBannerError('Error saving automation group', errorMsg));
  });

  return dispatch({
    type: SAVE_GROUP,
    promise
  });
}

export const fetchAutomation = (id) => (dispatch) => {
  // TODO
  setTimeout(() => dispatch({ type: FETCH_AUTOMATION_SUCCESS, payload: {
    id: 1,
    status: 'draft',
    name: 'Automation 1',
    group: 1,
    periodically_check_for_new_leads: true,
    exit_if_entry_condition_not_met: true,
    automation_type: 'small',
    goal_1: 'launch_focus_group',
    goal_2: 'post_project',
    goal_3: 'create_draft',
    goal_4: 'register_as_client',
    entry_condition: 'active_clients_with_a_draft_in_subcat',
    entry_condition_context: {
      marketing_segment: 'agency',
      sub_category: 23
    },
    extra_link_attributes: {
      utm_name: 'UTM name'
    },
    emails: [{
      order: 1,
      id: 1,
      variations: [{
        id: 1,
        'subject': 'Subject 2B',
        waiting_period: 1.5,
        from_email: 'john@example.com',
        from_name: 'John',
        text_content: 'Text content',
        'number': 1,
        html_content: 'asdasd',
html_design: {"counters":{"u_column":1,"u_row":1,"u_content_text":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">This is a new Text block. Chhange the text.</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"red","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}}
      }]
    }]
} }), 1000);

  return dispatch({
    type: FETCH_AUTOMATION,
    promise: request.get(`/api/v1/email-automations/${id}/`),
  });
};

export const sendTestEmail = (emailIdx, variationIdx, emails) => (dispatch, getState) => {
  const formValues = getState().form[AUTOMATION_FORM_NAME].values;
  const formData = {
    ...formValues,
    ...formValues.emails[emailIdx].variations[variationIdx]
  };
  return dispatch(sendTestEmailCommon(formData, emails));
}

export const saveAutomation = (id) => (dispatch, getState) => {
  const formData = getState().form[AUTOMATION_FORM_NAME].values || {};

  let entryCondition;
  if (formData.entry === "attribute") {
    entryCondition = formData.attribute_condition;
  } else if (formData.entry === "event") {
    entryCondition = formData.event_condition;
  }

  let entryConditionContext = {};
  if (entryCondition) {
    const condition = ATTRIBUTE_ENTRY_CONDITIONS.concat(EVENT_ENTRY_CONDITIONS).find(
      c => c.field === entryCondition
    );
    const extraContextKeys = (condition.extraContext || []).map(f => f.name);
    entryConditionContext = pick(formData, ...extraContextKeys);
  }

  const data = {
    ...pick(
      formData, 'name', 'group', 'periodically_check_for_new_leads',
      'exit_if_entry_condition_not_met', 'automation_type', 'goal_1', 'goal_2', 'goal_3', 'goal_4'
    ),
    entry_condition: entryCondition,
    entry_condition_context: entryConditionContext,
    extra_link_attributes: pick(formData, 'utm_source', 'utm_medium', 'utm_name'),
    emails: formData.emails.map((email, i) => ({
      ...email,
      order: i + 1,
      variations: email.variations.map((variation, j) => ({
        ...omit(variation, 'html_data'),
        number: j + 1,
        variation_allocation: (1/email.variations.length)*100,
        html_content: idx(variation, _ => _.html_data.html) || '',
        html_design: idx(variation, _ => _.html_data.design) || ''
      }))
    }))
  };

  //TODOconst promise = request.patch(`/api/v1/email-automations/${id}/`, data);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: {}});
    }, 1000);
  });

  promise.then(() => {
    dispatch(showBanner('Success', 'Automation successfully saved.', undefined, TYPE_SUCCESS));
    /* reset form so that admin notes are cleared */
    dispatch(reset(AUTOMATION_FORM_NAME));
    dispatch(fetchAutomation(id));
  }).catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Make sure the data you entered is correct.';
    dispatch(setBannerError('Error saving automation', errorMsg));
  });

  return dispatch({
    type: SAVE_AUTOMATION,
    promise
  });
}



// WEBPACK FOOTER //
// ./email_automations/ducks/bumblebee.js